<template>
    <div class="correcte-top ">
        <div class="correct-left">
            <img :src="user.photo" alt="" />
            {{ user.name }}
        </div>
        <!-- 显示箭头 -->
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: ['user'],
    // watch: {
    //     user(val) {
    //         console.log(val)
    //         this.user = val
    //     }
    // },

}
</script>

<style lang="scss" scoped>
.correcte-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // align-items: flex-start;
    width: 100%;
    height: 36px;
    line-height: 36px;


    .correct-left {
        img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            vertical-align: bottom;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/HeaderList.vue